import { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LogOut, ExternalLink } from "lucide-react";
import StrainsTab from "./StrainsTab";
import DropsTab from "./DropsTab";
import { SubscribersTab, InquiriesTab, BlastTab, ImportTab } from "./DataTabs";

const TABS = [
  { key: "strains", label: "Strains" },
  { key: "drops", label: "Drops" },
  { key: "inquiries", label: "Inquiries" },
  { key: "subscribers", label: "Subscribers" },
  { key: "blast", label: "Blast" },
  { key: "import", label: "Import" },
];

export default function Dashboard() {
  const { logout } = useAuth();
  const [tab, setTab] = useState("strains");

  return (
    <div className="grain min-h-screen bg-black">
      <header className="sticky top-0 z-40 border-b border-yaza-border bg-black/85 backdrop-blur-md">
        <div className="mx-auto flex max-w-[1400px] items-center justify-between px-5 py-4 md:px-8">
          <span className="font-display text-2xl">YAZA <span className="text-yaza-accent">EXOTICS</span> <span className="text-xs tracking-widest text-neutral-500">ADMIN</span></span>
          <div className="flex items-center gap-4">
            <Link to="/" target="_blank" className="inline-flex items-center gap-1 text-xs uppercase tracking-widest text-neutral-400 hover:text-white"><ExternalLink size={14} /> View Site</Link>
            <button onClick={logout} data-testid="admin-logout" className="inline-flex items-center gap-1 text-xs uppercase tracking-widest text-neutral-400 hover:text-yaza-accent"><LogOut size={14} /> Logout</button>
          </div>
        </div>
        <div className="mx-auto flex max-w-[1400px] gap-1 overflow-x-auto px-5 md:px-8">
          {TABS.map((t) => (
            <button
              key={t.key}
              onClick={() => setTab(t.key)}
              data-testid={`tab-${t.key}`}
              className={`whitespace-nowrap border-b-2 px-4 py-3 text-xs font-semibold uppercase tracking-widest transition-colors ${
                tab === t.key ? "border-yaza-accent text-yaza-accent" : "border-transparent text-neutral-500 hover:text-white"
              }`}
            >
              {t.label}
            </button>
          ))}
        </div>
      </header>

      <main className="mx-auto max-w-[1400px] px-5 py-10 md:px-8">
        {tab === "strains" && <StrainsTab />}
        {tab === "drops" && <DropsTab />}
        {tab === "inquiries" && <InquiriesTab />}
        {tab === "subscribers" && <SubscribersTab />}
        {tab === "blast" && <BlastTab />}
        {tab === "import" && <ImportTab />}
      </main>
    </div>
  );
}
